const DiscountStrategyEnum = {
    None: 'None',
    FixedAmount: 'FixedAmount',
    FixedReduction: 'FixedReduction',
    PercentageReduction: 'PercentageReduction',
}

export default DiscountStrategyEnum;